// src/features/media/useVideo.ts

import { useQuery } from '@tanstack/react-query';
import { MediaApi } from './MediaApi';
import { MEDIA_QUERY_KEYS } from '@/lib/constants/media';
import { useAuth } from '@/features/auth/hooks/useAuth';

/**
 * Fetch single video with full detail data (including texttracks).
 */
export function useVideo(mediaId: number) {
  const { selectedCId } = useAuth();

  return useQuery({
    queryKey: MEDIA_QUERY_KEYS.video(selectedCId ?? 0, mediaId),
    queryFn: () => MediaApi.getVideo(selectedCId!, mediaId),
    enabled: selectedCId != null && mediaId > 0,
    staleTime: 60 * 1000, // 1 minute
  });
}
